// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3J2MG","info":"Note_info__1S0Yn","note":"Note_note__2QrOB","actions":"Note_actions__m2sIh"};